const dwellingBlocks = {
  message: (controlIdNumber: number) => `/integrations/dwelling-blocks/cases/${controlIdNumber}/message/`,
  isIntegrated: (customerNumber: number) => `/integrations/dwelling-blocks/customers/${customerNumber}/is-integrated`,
};

export default dwellingBlocks;